import { render, staticRenderFns } from "./AdditiveWidget.vue?vue&type=template&id=d8c2487e&"
import script from "./AdditiveWidget.vue?vue&type=script&lang=js&"
export * from "./AdditiveWidget.vue?vue&type=script&lang=js&"
import style0 from "./AdditiveWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports